import { createContext } from 'react';
import type { Church } from '@/types/churches';

export type ChurchContextValue = {
  church: Church | null;
};

const defaultChurchContext: ChurchContextValue = {
  church: null,
};

export const ChurchContext = createContext<ChurchContextValue>(defaultChurchContext);
